import { createContext } from 'react';
import { IState } from '~/state';

const StateContext = createContext<IState|null>(null);

StateContext.displayName = 'StateContext';

export default StateContext;
export { IState };
